$ = require 'jquery'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
popoverShare = require 'app/scripts/views/templates/popover_share'
{ Noun, Verb, track, trackUe } = require '@trello/analytics'
{ dontUpsell } = require '@trello/config'
Controller = require 'app/scripts/controller'
Auth = require 'app/scripts/db/auth'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
{ renderComponent, ComponentWrapper } = require 'app/src/components/ComponentWrapper'
print = require('app/common/lib/util/print').default
{ IconName } = require 'app/common/components/controls/icon'
{ UpgradePromptPill } = require 'app/src/components/UpgradePrompts/UpgradePromptPill'
{ UpgradePromptFull } = require 'app/src/components/UpgradePrompts/UpgradePromptFull'
{ PlanSelectionOverlay } = require 'app/src/components/FreeTrial/PlanSelection'
{ renderUpgradePrompt } = require 'app/src/components/UpgradePrompts/renderUpgradePrompt'
l = require 'app/scripts/lib/localize'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ ExportPopoverContent } = require 'app/common/components/ExportPopoverContent'
BoardExportQuery = require('app/common/components/ExportPopoverContent/BoardExportQuery.graphql')
{ client } = require('@trello/graphql')

module.exports = class SharePopoverView extends View
  viewTitleKey: 'print and export'

  featureFlag = featureFlagClient.get('fv.export-service-export-board', false)
  freeTrialEnabled = featureFlagClient.get('btg.free-trial-existing-teams', false)

  events:
    'click .js-print': 'printModel'
    'click .js-export-json': 'exportJSON'
    'click .js-export': 'renderExportPopover'
    'click .js-export-csv': 'exportCSV'

  remove: ->
    @unmountPill?()
    super

  render: ->
    view = @
    org = @model.getOrganization()

    data = @model.toJSON()
    data.hasCsvExport = false

    data.hasOrganization = @model.hasOrganization()
    data.upgradeUrl = Controller.getUpgradeUrl(@model)
    data.isAdDismissed = Auth.me().isAdDismissed('share-popover')

    if org? && org?.isFeatureEnabled('csvExport')
      data.hasCsvExport = true
      data.csvURL = "/b/#{ @model.get('shortLink') }.csv"

    if org?.isPremium() && !org?.isFeatureEnabled('csvExport')
      data.needsUpgradeForCsv = true

    data.jsonURL = "/b/#{ @model.get('shortLink') }.json"

    data.upsellEnabled = !dontUpsell

    data.featureFlag = featureFlag

    @$el.html(popoverShare(data))

    isFreeTeam = org && !org.isPremium()
    billingUrl = @getBillingUrl(org)
    orgId = org?.id

    if !data.isAdDismissed && isFreeTeam
      $printAndExportUpgradePromptWrapper = @$('.print-and-export-upgrade-prompt-wrapper')[0]

      renderComponent(@adContainer(
        orgId, billingUrl, $printAndExportUpgradePromptWrapper
      ), $printAndExportUpgradePromptWrapper)

    if featureFlagClient.get('dataeng.gasv3-event-tracking', false)
      Analytics.sendScreenEvent
        name: 'printAndExportBoardInlineDialog'
        containers:
          board:
            id: @model.id

    @upgradePromptPill(billingUrl, orgId)
    @

  getBillingUrl: (org) ->
    if org
      return Controller.getOrganizationBillingUrl(org)
    return '/business-class'

  renderExportPopover: ->
    PopOver.pushView
      getViewTitle: -> l ['view title', 'export board'],
      reactElement: React.createElement(ComponentWrapper, {
        key: 'exportPopover',
        children: React.createElement(ExportPopoverContent, { idBoard: @model.id })
      })

  adContainer: (orgId, billingUrl, reactRoot) ->
    React.createElement(
      React.Fragment,
      null,
      React.createElement('hr', null),
      @upgradePrompt(orgId, billingUrl, reactRoot)
    )

  upgradePromptPill: (billingUrl, orgId) =>
    bcPillReactRoot = @$('#js-export-csv-pill-update-prompt')[0]

    onClick = ->
      trackUe({
        category: Noun.BOARD_MENU,
        verb: Verb.OPENS,
        directObj: Noun.TEAM_PAGE_BC_TAB,
        method: 'by clicking pill upgrade prompt in the board menu export page'
      })

      if freeTrialEnabled
        tempNode = document.createElement('span')
        bcPillReactRoot.appendChild(tempNode)
        renderComponent(React.createElement(PlanSelectionOverlay, {
            orgId: orgId,
            onContinue: => window.location.assign('/business-class')
            onClose: ->
              ReactDOM.unmountComponentAtNode(tempNode)
              tempNode.remove()
          }),
          tempNode, {
            boardModel: @model
          }
        )

    @unmountPill = renderUpgradePrompt(
      React.createElement(UpgradePromptPill, {
        cta: l(['upgrade prompt', 'upgrade']),
        ctaLink: if freeTrialEnabled then '' else billingUrl
        ctaOnClick: onClick,
        iconName: IconName.BusinessClass,
        isDismissable: false
      }),
      bcPillReactRoot, {
        boardModel: @model
      }
    )

  upgradePrompt: (orgId, billingUrl, reactRoot) ->
    props =
      content: l(['upgrade prompt', 'board menu', 'print and export', 'content-2'])
      headline: l(['upgrade prompt', 'board menu', 'print and export', 'headline-2'])
      cta: l(['upgrade prompt', 'learn more'])
      ctaLink: billingUrl
      orgId: orgId,
      source: 'moreMenuShareInlineDialog'
      ctaOnClick: => trackUe({
        category: Noun.BOARD_MENU,
        verb: Verb.OPENS,
        directObj: Noun.BC_MODAL,
        method: 'by clicking full upgrade prompt in the board menu export page'
      })
      iconName: IconName.Download
      isDismissable: true
      onDismiss: ->
        ReactDOM.unmountComponentAtNode(reactRoot)
        Auth.me().dismissAd('share-popover')

    React.createElement(
      UpgradePromptFull, props)

  printModel: (e) ->
    Util.stop(e)

    track('Board Menu', 'Print and Export Menu', 'Print')
    PopOver.hide()

    @defer ->
      print()

    return

  exportJSON: (e) ->
    track('Board Menu', 'Print and Export Menu', 'Export JSON')

  export: (e) ->
    track('Board Menu', 'Print and Export Menu', 'Export')

  exportCSV: (e) ->
    track('Board Menu', 'Print and Export Menu', 'Export CSV')
